"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;

var react_1 = require("react");

var query_string_1 = require("query-string");

function useQueryString(location, navigate, parseOptions, stringifyOptions) {
  var isFirst = (0, react_1.useRef)(true);

  var _a = (0, react_1.useState)((0, query_string_1.parse)(location.search, parseOptions)),
      state = _a[0],
      setState = _a[1];

  (0, react_1.useEffect)(function () {
    if (isFirst.current) {
      isFirst.current = false;
    } else {
      navigate(location.pathname + '?' + (0, query_string_1.stringify)(state, stringifyOptions));
    }
  }, [state]);

  var setQuery = function setQuery(values) {
    var nextState = typeof values === 'function' ? values(state) : values;
    setState(function (state) {
      return __assign(__assign({}, state), nextState);
    });
  };

  return [state, setQuery];
}

exports["default"] = useQueryString;